import { GridColumnType } from "../../../data/gridColumnType";

export const XeroPaymentUpdateListConfig = {
  columns: [
    {
      name: "Company Name",
      fieldName: "companyName",
      allowShort: false,
      colType: GridColumnType.Text,
    },
    {
      name: "Membership Type",
      fieldName: "membershipTier",
      colType: GridColumnType.Text,
    },
    {
      name: "Application Type",
      fieldName: "applicationType",
      colType: GridColumnType.Text,
    },
    {
      name: "Payment Term",
      fieldName: "paymentTerm",
      colType: GridColumnType.Text,
    },
      {
      name: "Invoice Number",
      fieldName: "invoiceNumber",
      colType: GridColumnType.LINK,
      colSettings: {
        isOpenNewTab: true,
        url: "$invoiceLink",
      },
    },
    {
      name: "Invoice Amount",
      fieldName: "totalAmount",
      colType: GridColumnType.Text,
    },
     {
      name: "Status",
      fieldName: "status",
      colType: GridColumnType.Text,
    },
    {
      name: "Payment Date",
      fieldName: "date",
      colType: GridColumnType.Text,
    },
   
    {
      name: "Actions",
      colType: GridColumnType.ACTION,
      defaultAction: {
        allowEdit: false,
        allowDelete: false,
        otherAction:true
      },
      colSetting:{
        btnText:"Send Email",
        isDisable:"isDisable",
        btnClassName:"xero-sendbtn"
        // onclick:(data) => {
        //     alert("Send action clicked");
        //   },
      }
      // customAction: [
      //   {
      //     name: "Send",
      //     onViewAction: (data) => {
      //       alert("Send action clicked");
      //     },
      //   },
      // ],
    },
  ],
};
